import './index.scss'
$(function() {
    $(".item-list .item a").hover(function() {
        $(this).children('.none').css({
            "opacity": 1
        })
        // $('.pro-common-honor .tabitem .tab-body>div').eq($(this).index()).show().siblings().hide();
    }, function() {
        $(this).children('.none').css({
            "opacity": 0
        })
    });
});